import { getSystemIcon, SystemIcon } from '@helpers/icons';
import { getSrcs } from '@helpers/image';
import { Device, from, until } from '@helpers/media';
import { FakeButton } from '@stories/Components/Buttons/Button/Button';
import * as React from 'react';
import S from './SignpostCard.styles';
const SignpostCard = (props) => {
    const imageSrc = props.image ? getSrcs(props.image, 962, 700, 3, 417 / 240) : null;
    const pairSrc = props.image && props.perRow === 2 ? getSrcs(props.image, 1706, 962, 4, 853 / 290) : null;
    const sizes = props.perRow === 2
        ? `${until(Device.MobileLarge)} 100vw, ${until(Device.ActualDesktop)} 50vw, 583px`
        : props.perRow === 3
            ? `${until(Device.MobileLarge)} 100vw, ${until(Device.TabletLarge)} 50vw, ${until(Device.ActualDesktop)} 33vw, 562px`
            : `${until(Device.MobileLarge)} 100vw, ${until(Device.TabletLarge)} 50vw, ${until(Device.DesktopSmall)} 33vw, ${until(Device.ActualDesktop)} 25vw, 562px`;
    return (React.createElement(S.Container, { href: props.cta?.url, target: props.cta?.target, "data-theme": props.typeTheme ?? 'default', "data-has-media": !!props.image || !!props.icon || props.icon === SystemIcon.None, "data-is-pair": props.perRow === 2 },
        React.createElement(S.ImageContainer, { "data-bg-color": !!props.image || !!props.icon || props.icon === SystemIcon.None
                ? props.typeTheme ?? 'intermediary'
                : 'transparent' },
            imageSrc && props.image && !props.icon ? (React.createElement("picture", null,
                pairSrc && (React.createElement("source", { srcSet: imageSrc.srcSet, media: `${from(Device.TabletLarge)}`, sizes: sizes })),
                React.createElement(S.Image, { src: imageSrc.src, srcSet: imageSrc.srcSet, alt: props.image.altText ?? props.title, loading: "lazy", sizes: sizes }))) : null,
            props.icon && getSystemIcon(props.icon ?? SystemIcon.SpeechBubble)),
        React.createElement(S.ContentWrapper, null,
            React.createElement(S.ContentArea, null,
                React.createElement(S.Heading, null, props.title),
                props.description && React.createElement(S.Description, null, props.description))),
        React.createElement(S.FakeButtonWrapper, null,
            React.createElement(FakeButton, { buttonType: props.typeTheme === 'mortgages' ? 'default' : props.typeTheme ?? 'default', iconOnly: true }, getSystemIcon(SystemIcon.ArrowRight)))));
};
export default SignpostCard;
